define([
	"dojo/_base/declare",
	"underscore",
	"csi/action/AggregateController",
	"csi/comm",
	"./util"
], function(declare, _, AggregateController, comm, util) {

	return declare(AggregateController, {
		/**
		 * Add aggregate nodes for shared sections in edit mode or that are unlinked
		 */
		onFormData: function(fd) {
			var ctx = this.getContext();
			var sharedSectionUrls = util.getDataSheetSharedSectionUrls(ctx, this.getParent());
			var sections = ctx.cache.getNodes(sharedSectionUrls);

			_.each(sections, function(section) {
				fd.addAggregatedNode(section);
			});
		},

		/**
		 * @override
		 * When adding a shared section, a ValuesByXML query is sent to the server right after creating the new nodes; if the 
		 * query accelerator is being used, it may not have the new nodes yet, so disable it temporarily
		 */
		postProcessSuccess: function() {
			comm.bypassQueryAccelerator();
			return this.inherited(arguments);
		}
	});
});
